const serviceLookup = (serviceName: string): any => {
    const startupData = window.dazn.startupData as any;
    if (!startupData.ServiceDictionary[serviceName]) {
        throw new Error(
            `startupData.ServiceDictionary.${serviceName} is undefined`
        );
    }

    return startupData.ServiceDictionary[serviceName].Versions;
};

type UseFetchType = {
    data: any;
    loading: boolean;
    error: any;
};

interface Props {
    serviceKey: string;
    version: string;
    path?: string;
    body?: any;
    headers?: {[key: string]: string};
    onSuccess?: (data: any) => void;
    enabled?: boolean;
    fetchURL?: string;
    method?: 'GET' | 'POST';
}

const Fetch = async ({
    serviceKey,
    version,
    path,
    body,
    headers = {},
    method = 'GET'
}: Props): Promise<UseFetchType> => {
    let data = null;
    let error = null;
    let loading = false;

    const fetchUrl = serviceLookup(serviceKey)[version].ServicePath;

    try {
        loading = true;
        const response = await fetch(fetchUrl + (path || ''), {
            method,
            headers: {'Content-Type': 'application/json', ...headers},
            ...(body && {body: JSON.stringify(body)})
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const fetchedData = await response.json();
        data = fetchedData;
        error = null;
    } catch (err) {
        error = err;
        console.error(err);
        data = null;
    } finally {
        loading = false;
    }

    return {data, error, loading};
};

export default Fetch;
